<template>
  <div>
    <v-container>
      <v-toolbar dense flat color="transparent">
        <v-toolbar-title class="font-weight-bold"
          >Update Category</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn class="mx-lg-3 black white--text">Update</v-btn>
      </v-toolbar>
      <v-row>
        <v-col>
          <p class="text-center">Category</p>
          <v-text-field outlined v-model="locations.name"></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locations: {
        name: "Service Excellence"
      }
    };
  }
};
</script>
